import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="relative py-24 bg-gradient-to-br from-amber-50 to-orange-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
                About DDR CONSTRUCTION SOLUTIONS
              </h1>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Your trusted partner for quality construction and remodeling services
              </p>
            </div>
          </div>
        </section>

        {/* About Content */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  Dependable Quality for All Things Construction
                </h2>
                <p className="text-lg text-gray-600 mb-6">
                  At DDR CONSTRUCTION SOLUTIONS, we pride ourselves on delivering exceptional craftsmanship and reliable service for every project. Whether it's a small repair or a major renovation, we approach each job with the same level of dedication and attention to detail.
                </p>
                <p className="text-lg text-gray-600 mb-6">
                  Led by James and his skilled team, we've built our reputation on quality workmanship, honest pricing, and customer satisfaction. We use better materials and work efficiently to ensure your project is completed to the highest standards.
                </p>
                <p className="text-lg text-gray-600">
                  From deck construction and restoration to custom carpentry and home repairs, we handle any job, any size. Our commitment is simple: deliver excellent results that exceed your expectations.
                </p>
              </div>
              <div>
                <img
                  src="https://public.readdy.ai/ai/img_res/ac1da4093d31f6d9241e8e9724be1ecc.jpg"
                  alt="DDR CONSTRUCTION SOLUTIONS Team at Work"
                  className="rounded-lg shadow-xl w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us */}
        <section className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Why Choose DDR CONSTRUCTION SOLUTIONS
              </h2>
              <p className="text-xl text-gray-600">
                What sets us apart from the competition
              </p>
            </div>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-hammer-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Quality Materials</h3>
                <p className="text-gray-600">
                  We use better materials for every job, ensuring durability and longevity for your investment.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-time-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Fast & Efficient</h3>
                <p className="text-gray-600">
                  We work quickly without compromising quality, respecting your time and schedule.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-star-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Skilled Craftsmen</h3>
                <p className="text-gray-600">
                  Highly skilled professionals with attention to detail and years of experience.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-customer-service-2-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Responsive Service</h3>
                <p className="text-gray-600">
                  Available when you need us, including emergency repairs. We're here to help.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-money-dollar-circle-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Fair Pricing</h3>
                <p className="text-gray-600">
                  Competitive rates with transparent pricing. Worth every dollar you invest.
                </p>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-amber-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">Satisfaction Guaranteed</h3>
                <p className="text-gray-600">
                  We ensure everything is done to your satisfaction and address any concerns promptly.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-amber-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-4xl font-bold text-white mb-6">
              Ready to Start Your Project?
            </h2>
            <p className="text-xl text-white/90 mb-8">
              Get a free estimate today. Any job, any size.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:502-533-0524"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-amber-600 bg-white rounded-lg hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Call 502-533-0524
              </a>
              <a
                href="/#contact"
                className="inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
              >
                Request Free Estimate
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
